<template>
  <div>
    <el-table
      ref="customerTable"
      :data="tableData"
      style="width: 100%;color: black;"
      class="--modal-table"
      v-loading="isLoading"
      element-loading-text="Loading data...">
      <!-- @selection-change="handleSelectionChange"> -->
      <!-- <el-table-column type="selection" width="55" /> -->
      <el-table-column width="55" align="center">
        <template slot-scope="scope">
          <el-radio 
            :label="getRowId(scope.row, scope.$index)" 
            v-model="selectedRowId"
            :disabled="deletingRowId == scope.row.id"
            @change="handleRadioChange(scope.row)">
          </el-radio>
        </template>
      </el-table-column>

      <el-table-column label="Uploaded Date" width="200">
        <template slot-scope="scope">{{ scope.row.date }}</template>
      </el-table-column>

      <el-table-column property="name" label="Customer List Name" width="300">
      </el-table-column>

      <el-table-column property="total" label="Total Customers" show-overflow-tooltip>
      </el-table-column>

      <el-table-column label="Action" align="right">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            icon="el-icon-download" 
            style="color: #000000; font-size: 16px;" 
            @click="onDownloadClicked(scope.row)"
            :title="'Download ' + scope.row.name"
          ></el-button>
          <el-button 
            v-if="deletingRowId == scope.row.id"
            type="text" 
            icon="el-icon-loading" 
            style="color: #000000; font-size: 16px;"
            :class="{'is-loading': true}"
          ></el-button>
          <el-button 
            v-else
            type="text" 
            icon="el-icon-delete" 
            style="color: #000000; font-size: 16px;" 
            @click="onDeleteClicked(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
      
      <template slot="empty">
        <div v-if="isLoading" class="table-empty-loading">
          <i class="fas fa-spinner fa-pulse"></i>
          <span>Loading data...</span>
        </div>
        <span v-else>No Data</span>
      </template>
    </el-table>
    
    <!-- Pagination -->
    <div v-if="pagination && pagination.total > 0" class="d-flex justify-content-between align-items-center mt-3">
      <div class="pagination-info-wrapper">
        <span v-if="currentRow && currentRow.id" class="customer-selected-badge">
          <i class="fas fa-check-circle"></i> Customer list selected ({{ currentRow.name }})
        </span>
        <span class="pagination-info-text">Showing {{ pagination.from || 0 }} to {{ pagination.to || 0 }} of {{ pagination.total || 0 }} entries</span>
      </div>
      <base-pagination
        class="userclient-pagination"
        type="default"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="pagination.total"
        @input="onPageChange"
      ></base-pagination>
    </div>
  </div>
</template>

<script>
import {
  Table, TableColumn, Dropdown,
  DropdownMenu,
  DropdownItem,
  Radio,
  Button
} from 'element-ui';
import { Notification } from 'element-ui';
import { Loading } from 'element-ui';
import swal from 'sweetalert2';
import { downloadFileInBackgroundCleanID } from '../../helpers/downloadFile';
import BasePagination from '../BasePagination.vue';
export default {
  directives: { loading: Loading.directive },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Radio.name]: Radio,
    [Button.name]: Button,
    BasePagination
  },

  props: {
    userId: { 
      required: true,
    },
    initialSelection: {
      type: Object,
      default: null
    },
    selectedAudienceIds: {
      type: Array,
      default: () => []
    },
    searchQuery: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      tableData: [
        // {
        //   date: '2016-05-03',
        //   name: 'Tom',
        //   total: '50',
        //   url: 'https://space.com',
        //   size_file: '100',
        // }, {
        //   date: '2016-05-02',
        //   name: 'Tom',
        //   total: '50',
        //   url: 'https://space.com',
        //   size_file: '100',
        // }
      ],
      currentRow: null,
      selectedRowId: null,
      deletingRowId: null,
      isLoading: false,
      pagination: {
        currentPage: 1,
        perPage: 5,
        total: 0,
        lastPage: 1,
        from: 0,
        to: 0
      }
    }
  },

  methods: {
    // handleSelectionChange(val) {
    //   // Enforce single selection while keeping checkbox UI.
    //   if (Array.isArray(val) && val.length > 1) {
    //     const last = val[val.length - 1];
    //     this.$refs.customerTable.clearSelection();
    //     this.$nextTick(() => {
    //       this.$refs.customerTable.toggleRowSelection(last, true);
    //     });
    //     this.currentRow = last;
    //   } else {
    //     this.currentRow = val && val.length ? val[0] : null;
    //   }
    //   this.$emit('select', this.currentRow);
    // },

    handleRadioChange(row) {
      // Simpan ID ke selectedRowId (untuk v-model)
      this.selectedRowId = row.id !== undefined ? row.id : null;

      // Simpan seluruh object row (bukan hanya ID)
      this.currentRow = row;  // ← Ini menyimpan seluruh object seperti sekarang
      
      // console.log('handleRadioChange', {
      //   'selectedRowId': this.selectedRowId,
      //   'currentRow': this.currentRow,
      //   'url': row.url  // ← URL dari customer list
      // });
      
      // Emit seluruh object row ke parent
      this.$emit('select', this.currentRow);
    },

    getRowId(row, index) {
      // Return ID untuk v-model radio button
      return row.id !== undefined ? row.id : `row-${index}`;
    },

    async refresh() {
      await this.getCustomer(this.userId, this.pagination.currentPage);
    },

    async getCustomer(userId, page = 1) {
      this.tableData = [];
      this.isLoading = true;
      
      // Store current selection before fetching new page
      const previousSelectedId = this.selectedRowId;
      
      await this.$store.dispatch('getCustomerPredict', {
        userId: userId,
        page: page,
        perPage: this.pagination.perPage,
        search: this.searchQuery || ""
      })
      .then(response => {
        this.tableData = response.customers || [];
        
        // Update pagination info
        if (response.pagination) {
          this.pagination.currentPage = response.pagination.currentPage ? response.pagination.currentPage : 1;
          this.pagination.perPage = response.pagination.perPage ? response.pagination.perPage : 8;
          this.pagination.total = response.pagination.total ? response.pagination.total : 0;
          this.pagination.lastPage = response.pagination.lastPage ? response.pagination.lastPage : 1;
          this.pagination.from = response.pagination.from ? response.pagination.from : 0;
          this.pagination.to = response.pagination.to ? response.pagination.to : 0;
        }

        // Restore selection jika ada initialSelection atau previous selection
        const targetId = (this.initialSelection && this.initialSelection.id) ? this.initialSelection.id : previousSelectedId;
        
        if (targetId) {
          const selectedRow = this.tableData.find(row => (row.id !== undefined ? row.id : null) === targetId);
          
          if (selectedRow) {
            // Restore selection setelah data di-load
            this.selectedRowId = selectedRow.id;
            this.currentRow = selectedRow;
            // Emit selection to parent to keep it in sync
            this.$emit('select', this.currentRow);
          } else {
            // Selection tidak ada di halaman ini
            if (this.initialSelection && this.initialSelection.id === targetId) {
              // Jika initialSelection ada dan ID-nya sama, pertahankan currentRow dari initialSelection
              // Ini memastikan badge "Customer list selected" tetap muncul meskipun tidak di halaman saat ini
              this.selectedRowId = this.initialSelection.id;
              this.currentRow = this.initialSelection;
            } else {
              // Only clear if it's not from initialSelection
              this.selectedRowId = null;
              this.currentRow = null;
            }
          }
        } else if (this.initialSelection && this.initialSelection.id) {
          // Jika tidak ada targetId tapi ada initialSelection, tetap set currentRow
          this.selectedRowId = this.initialSelection.id;
          this.currentRow = this.initialSelection;
        }
      })
      .catch(error => {
        this.tableData = [];
        this.selectedRowId = null;  // Reset ID
        this.currentRow = null; // Reset object (tetap seperti sekarang)
        // Reset pagination on error
        this.pagination.currentPage = 1;
        this.pagination.perPage = 5;
        this.pagination.total = 0;
        this.pagination.lastPage = 1;
        this.pagination.from = 0;
        this.pagination.to = 0;
      })
      .finally(() => {
        this.isLoading = false;
      })
    },
    
    onPageChange(page) {
      this.pagination.currentPage = page;
      this.getCustomer(this.userId, page);
    },
    
    onSearch() {
      // Search when Enter is pressed
      // Reset to page 1 when searching
      // Note: Selection will be preserved through previousSelectedId or initialSelection
      this.pagination.currentPage = 1;
      this.getCustomer(this.userId, 1);
    },
    
    onDownloadClicked(row) {
      const appDataServerUrl = process.env.VUE_APP_DATASERVER_URL;
      const customer_id = row && row.id ? row.id : "";
      const customer_name = row && row.name ? row.name.replace(/ /g, '_') : "";
      const file_name = `${customer_name}.csv`;
      const url = `${appDataServerUrl}/configuration/predict-id/download-customer/${customer_id}`;
      downloadFileInBackgroundCleanID(url, file_name);
    },

    onDeleteClicked(row) {
      if (this.deletingRowId === row.id) return; // prevent double click

      // Show confirmation
      swal.fire({
        title: 'Delete customer list?',
        text: 'This action cannot be undone.',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (!result.isConfirmed) return;

        // Start loading state
        this.deletingRowId = row.id;

        // Call store action
        this.$store.dispatch('PredictRemoveCustomer', { customerId: row.id })
        .then(async () => {
          // Refresh table and notify
          // If deleted row was on current page and it's the last item, go to previous page
          if (this.tableData.length === 1 && this.pagination.currentPage > 1) {
            this.pagination.currentPage = this.pagination.currentPage - 1;
          }
          await this.refresh();
          
          // Clear selection if the deleted row was selected
          this.$emit('after-delete', row); // Emit event to parent
          if (this.deletingRowId == this.selectedRowId) {
            // console.log('Deleted row was selected, clearing selection');
            this.selectedRowId = null;
            this.currentRow = null;
          }
          
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                <i class="el-notification__icon el-icon-success" style="margin-right: 10px;"></i> 
                <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Success</span>
              </p>
              <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                Customer list has been deleted successfully
              </p>
            `,
            duration: 3000,
            dangerouslyUseHTMLString: true
          });
        })
        .catch((error) => {
          const messageError = (error && error.message) ? error.message : 'Failed to delete customer list';
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                <i class="el-notification__icon el-icon-error" style="margin-right: 10px;"></i> 
                <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Error</span>
              </p>
              <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                ${messageError}
              </p>
            `,
            duration: 3000,
            dangerouslyUseHTMLString: true
          });
        })
        .finally(() => {
          this.deletingRowId = null;
        });
      });
    }
  },

  watch: {
    userId: {
      immediate: true,
      handler(newVal) {
        if (newVal != '') {
          this.getCustomer(newVal);
        }
      }
    },
    initialSelection: {
      handler(newVal, oldVal) {
        // Jika initialSelection berubah dan ada, set currentRow untuk memastikan badge tetap muncul
        // Ini penting saat user kembali dari halaman lain (back/next)
        if (newVal && newVal.id) {
          // Hanya update jika berbeda dari currentRow untuk menghindari loop
          if (!this.currentRow || this.currentRow.id !== newVal.id) {
            this.selectedRowId = newVal.id;
            this.currentRow = newVal;
          }
        } else if (!newVal && oldVal) {
          // Jika initialSelection menjadi null setelah sebelumnya ada, clear selection
          // Tapi hanya jika tidak ada di tableData saat ini
          if (!this.tableData.find(row => row.id === this.selectedRowId)) {
            this.selectedRowId = null;
            this.currentRow = null;
          }
        }
      }
    }
  }
}
</script>
<style>
.--modal-table.el-table table {
  color: unset !important;
}

/* Hide radio button label text (menghilangkan angka) */
.--modal-table .el-radio__label {
  display: none !important;
  padding: 0 !important;
  width: 0 !important;
}
/* Hide radio button label text (menghilangkan angka) */

/* Perbesar ukuran radio button */
.--modal-table .el-radio {
  font-size: 18px;  /* Atur sesuai kebutuhan */
}
.--modal-table .el-radio__inner {
  width: 18px !important;      /* Ukuran bulatan */
  height: 18px !important;     /* Ukuran bulatan */
  border-width: 2px !important; /* Ketebalan border */
}
/* Perbesar ukuran radio button */

/* Perbesar titik di tengah saat dipilih */
.--modal-table .el-radio__inner::after {
  width: 8px !important;   /* Ukuran titik */
  height: 8px !important;  /* Ukuran titik */
}
/* Perbesar titik di tengah saat dipilih */

/* Empty slot loading layout (vertical stack) */
.table-empty-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
}
.table-empty-loading i {
  font-size: 20px;
  color: #6b7280;
}
.table-empty-loading span {
  font-size: 14px;
  color: #222a42;
}

/* Pagination info styling */
.pagination-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.customer-list-name-text {
  font-size: 12px;
  color: #000000;
  font-weight: 500;
}

.pagination-info-text {
  font-size: 12px;
  color: #6b7280;
}

.customer-selected-badge {
  font-size: 11px;
  color: #059669;
  display: flex;
  align-items: center;
  gap: 4px;
}

.customer-selected-badge i {
  font-size: 12px;
}

/* Custom pagination color for UserClient only */
/* Override .modal-content .modal-body a untuk pagination saja dengan selector yang lebih spesifik */
.modal-content .modal-body .userclient-pagination.pagination-default a.page-link,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default a.page-link,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item a.page-link {
  color: #000000 !important;
}

.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item a.page-link i,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item a.page-link .tim-icons {
  color: #000000 !important;
}

.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link:focus,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link:hover {
  background-color: #000000 !important;
  color: #ffffff !important;
  border-color: #000000 !important;
}

.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link i,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link:focus i,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link:hover i,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.active a.page-link .tim-icons {
  color: #ffffff !important;
}

.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.disabled a.page-link,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.disabled a.page-link i,
.modal-content .modal-body .userclient-pagination .pagination.pagination-default .page-item.disabled a.page-link .tim-icons {
  color: #9ca3af !important;
}
</style>
